import { Component, computed, inject, input, output, signal } from '@angular/core';
import { ButtonThemeColor, KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { TransitionMiniDto, TransitionRequestDto, UnityWorkflowState } from '@unity/clients';
import { icons, IconService } from '@unity/services/icon.service';
import { DialogTransitionConfirmationSharedComponent } from '@unity/shared/dialog-transition-confirmation-shared/dialog-transition-confirmation-shared.component';
import { QuickActionProps } from '@unity/utils/types';
import { ActionSharedComponent } from '../action-shared/action-shared.component';

@Component({
  selector: 'unity-action-transition-shared',
  imports: [KENDO_BUTTON, DialogTransitionConfirmationSharedComponent, ActionSharedComponent],
  templateUrl: './action-transition-shared.component.html',
  styleUrl: './action-transition-shared.component.scss',
})
export class ActionTransitionSharedComponent {
  private readonly iconService = inject(IconService);

  protected redoIcon = this.iconService.redoIcon;
  protected plusIcon = this.iconService.plusIcon;
  protected cancelIcon = this.iconService.cancelIcon;
  protected arrowRightIcon = this.iconService.arrowRightIcon;

  protected readonly $showConfirmDialog = signal(false);

  protected readonly $action = computed(() => {
    const transition = this.$transition();

    const props: QuickActionProps = {
      actionName: transition.name,
      icon: this.transitionIcon,
      description: transition.name,
    };
    return props;
  });

  public readonly $transition = input.required<TransitionMiniDto>({ alias: 'transition' });
  public readonly $disabled = input.required<boolean>({ alias: 'disabled' });

  public doTransitionEvent = output<TransitionRequestDto>();

  protected emptyButton = '';
  protected readonly $iconTheme = signal<ButtonThemeColor>('secondary');

  protected get transitionIcon(): keyof typeof icons {
    const toState = this.$transition().to_state_enum_value;
    switch (toState) {
      case UnityWorkflowState.Completed:
      case UnityWorkflowState.Approved:
        return 'redoIcon';
      case UnityWorkflowState.Planned:
        return 'plusIcon';
      case UnityWorkflowState.Disabled:
      case UnityWorkflowState.Rejected:
        return 'cancelIcon';
      default:
        return 'arrowRightIcon';
    }
  }

  protected onOpen() {
    this.$showConfirmDialog.set(true);
  }

  protected onClose() {
    this.$showConfirmDialog.set(false);
  }

  protected onTransition(event: TransitionRequestDto) {
    this.doTransitionEvent.emit(event);
  }
}
